import { useTranslation } from '@fanfanlo'
import { ITriggerScriptData } from './ITriggerScript.inft'
import { scriptTriggerSimpleTemplate, scriptTriggerAdvancedTemplate, scriptTriggerFullTemplate } from '../scriptTemplates'
import { Box, TextField, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material'
import { useState } from 'react'

type ScriptMode = 'simple' | 'advanced' | 'full'

/**
 * TriggerScript UI 组件
 * 脚本触发器编辑器
 */
export function UI(data: ITriggerScriptData) {
    const { t } = useTranslation('droid-project-v2-ext/triggers/script/script-trigger/content')

    const [mode, setMode] = useState<ScriptMode>('simple')
    const [code, setCode] = useState(data.javaData.script || scriptTriggerSimpleTemplate)

    function handleModeChange(newMode: ScriptMode) {
        setMode(newMode)
        let template = scriptTriggerSimpleTemplate
        if (newMode === 'advanced') {
            template = scriptTriggerAdvancedTemplate
        } else if (newMode === 'full') {
            template = scriptTriggerFullTemplate
        }
        setCode(template)
        data.javaData.script = template
    }

    function handleCodeChange(newCode: string) {
        setCode(newCode)
        data.javaData.script = newCode
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ mb: 2 }}>
                <Typography variant="h6" component="b">
                    {t('UI.title')}
                </Typography>
            </Box>

            <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>{t('UI.scriptMode')}</InputLabel>
                <Select
                    data-testid="ScriptTriggerUI__modeSelect__01JFXYZR1H7I8J9K0L1M2N3O4"
                    value={mode}
                    label={t('UI.scriptMode')}
                    onChange={(e) => handleModeChange(e.target.value as ScriptMode)}
                >
                    <MenuItem value="simple">{t('UI.scriptMode_simple')}</MenuItem>
                    <MenuItem value="advanced">{t('UI.scriptMode_advanced')}</MenuItem>
                    <MenuItem value="full">{t('UI.scriptMode_full')}</MenuItem>
                </Select>
            </FormControl>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {mode === 'simple' && t('UI.modeDescription_simple')}
                {mode === 'advanced' && t('UI.modeDescription_advanced')}
                {mode === 'full' && t('UI.modeDescription_full')}
            </Typography>

            <TextField
                data-testid="ScriptTriggerUI__codeEditor__01JFXYZS2I8J9K0L1M2N3O4P5"
                fullWidth
                multiline
                rows={12}
                label={t('UI.scriptCode')}
                value={code}
                onChange={(e) => handleCodeChange(e.target.value)}
                placeholder={t('UI.scriptPlaceholder')}
                sx={{ fontFamily: 'monospace' }}
            />
        </Box>
    )
}
